import { WellnessWheelArcProps } from "../types";

export default function HealthCategoryArc({
  arcColorFill,
}: WellnessWheelArcProps) {
  return (
    <path
      d="M138.5 247.553C78.2321 247.553 29.375 198.243 29.375 137.417"
      stroke={arcColorFill}
      strokeWidth="50.521"
      strokeLinecap="round"
      style={{
        strokeDasharray: 1000,
        strokeDashoffset: 1000,
        animation: "drawArc 1.4s ease-out 1.5s forwards",
      }}
    />
  );
}
